<div class="l-page">
	<super-panel/>
	<popin/>
	<notification/>
	<router-view/>
</div>
